import localeData from '@wix/locale-dataset-javascript';

import { SubdivisionType } from '../store/slices/locale/slice';

// Although it's improbable that a new subdivision type will appear
// we still don't want to accidentally show some translated label that we do not have
const getSubdivisionType = (subdivisionType: SubdivisionType | undefined) => {
  if (!subdivisionType) {
    return undefined;
  }
  return Object.values(SubdivisionType).includes(subdivisionType)
    ? subdivisionType
    : SubdivisionType.STATE;
};

export const getCountriesData = (allSubdivisionsSupported: boolean) =>
  localeData.getAllCountries().map((country) => {
    const subdivisionType = getSubdivisionType(
      country.subdivisions?.type as SubdivisionType | undefined,
    );
    const shouldReturnSubdivisions =
      allSubdivisionsSupported || subdivisionType === SubdivisionType.STATE;
    return {
      displayName: country.displayName,
      key: country.shortKey!,
      subdivisionType,
      subdivisions: shouldReturnSubdivisions
        ? country.subdivisions?.list ?? []
        : [],
    };
  });
